import { Injectable } from '@angular/core';
import { MmDialogConfig } from '@metromarkets/components';
import { TranslateService } from '@ngx-translate/core';
import { OrderHistoryItem } from '../models';

@Injectable()
export class OrderHistoryDialogConfigService {

  public get returnOrderLineConfirmationConfig() {
    return {
      data: {
        title: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_CONFIRM_DIALOG.TITLE'),
        message: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_CONFIRM_DIALOG.TEXT'),
        cancel: {
          label: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.CANCEL_BUTTON'),
        },
        submit: {
          label: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.CONFIRM_BUTTON_2'),
        },
      },
    };
  }

  public get cancelReturningConfig(): MmDialogConfig {
    return {
      data: {
        title: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.CANCEL_RETURN_DIALOG.TITLE'),
        message: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.CANCEL_RETURN_DIALOG.TEXT'),
        cancel: {
          label: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.CANCEL_RETURN_DIALOG.CANCEL_BUTTON'),
        },
        submit: {
          color: 'primary',
          label: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.CANCEL_RETURN_DIALOG.SUBMIT_BUTTON'),
        },
      },
    };
  }

  constructor(private translateSrv: TranslateService) {
  }

  public getCancelOrderConfig(orderNumber: string): MmDialogConfig {
    return {
      data: {
        title: this.translateSrv.instant(
          'PAGES.ACCOUNT.ORDERS_HISTORY.CANCEL_ORDER_DIALOG.TITLE',
          { orderNumber },
        ),
        message: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.CANCEL_ORDER_DIALOG.TEXT'),
      },
    };
  }

  public getReturnOrderConfig(orderNumber: string, order: OrderHistoryItem): MmDialogConfig {
    return {
      data: {
          order,
          title: this.translateSrv
            .instant(
              'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_ORDER_DIALOG.TITLE',
              { orderNumber },
            ),
        },
    };
  }

  public getCancelOrderLineConfig(productName: string) {
    return {
      data: {
        title: this.translateSrv.instant(
          'PAGES.ACCOUNT.ORDERS_HISTORY.CANCEL_ORDER_LINE_DIALOG.TITLE',
          { name: productName },
        ),
        message: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.CANCEL_ORDER_LINE_DIALOG.TEXT'),
      },
    };
  }

  public getPartialCancelConfirmationConfig(productName: string): MmDialogConfig {
    return {
      data: {
        title: this.translateSrv.instant(
          'PAGES.ACCOUNT.ORDERS_HISTORY.QUANTITY_PRODUCT_CONFIRM_DIALOG.TITLE',
          { productName },
        ),
        message: this.translateSrv.instant('PAGES.ACCOUNT.ORDERS_HISTORY.QUANTITY_PRODUCT_CONFIRM_DIALOG.TEXT'),
        cancel: {
          label: this.translateSrv
            .instant('PAGES.ACCOUNT.ORDERS_HISTORY.QUANTITY_PRODUCT_CONFIRM_DIALOG.CANCEL_BUTTON'),
        },
        submit: {
          label: this.translateSrv
            .instant('PAGES.ACCOUNT.ORDERS_HISTORY.QUANTITY_PRODUCT_CONFIRM_DIALOG.CONFIRM_BUTTON'),
        },
      },
    };
  }
}
